import React from "reactn";

import PropTypes from "prop-types";

//components
import EditableProductWrapper from "../editable_form/EditableProduct";

//styled components
import SelectedProductsStyled from "./SelectedProducts.styled";

const SelectedProducts = props => {
    const checkSelectedProducts = data => {
        let config = [];
        data.products.forEach(product => {
            if (values[product.id]) {
                config.push(product);
            }
        });
        return config;
    }
    const { values, config } = props;
    return (
        <SelectedProductsStyled>
            <>
                {config.map(data => (
                    <>
                        {checkSelectedProducts(data).length > 0 &&
                            <>
                                <EditableProductWrapper
                                    title={data.title}
                                    config={checkSelectedProducts(data)}
                                ></EditableProductWrapper>
                            </>
                        }
                    </>
                ))}
            </>
        </SelectedProductsStyled>
    );
};

SelectedProducts.propTypes = {
    config: PropTypes.array,
    values: PropTypes.array
};

export default SelectedProducts;
